import { Button } from "components/Button"
import { useTranslator } from "components/Translator"
import {
  Comments,
  PhoneAlt,
  At,
  MousePointer,
  Whatsapp,
  Skype,
} from "components/Icon"
import { RequireClub } from "components/RequireClub"
import { Text } from "components/Text"
import { replaceAll } from "utils/replaceAll"
import * as React from "react"
import * as R from "remeda"

const getPhoneHref = (phone) => {
  return `tel:${replaceAll(phone.formatted, " ", "")}`
}

export const ContactMethods = ({
  user,
  advert,
  shouldRequireClub,
  canSendDirectMessage,
  onDirectMessageClick,
}) => {
  const translator = useTranslator()

  const [showOtherContactMethods, setShowOtherContactMethods] =
    React.useState(false)

  const otherContactMethodsTitle = translator.trans(
    "ProfilePage.contactMethods.otherContactMethods",
    null,
    "components",
  )

  const directMessageButton = R.pipe(
    <Button
      color="secondary"
      type="button"
      onClick={onDirectMessageClick}
      iconLeft={<Comments className="w-4" />}
      key={"direct-message"}
    >
      {translator.trans(
        "ProfilePage.contactMethods.directMessage",
        null,
        "components",
      )}
    </Button>,
    R.when(
      () => shouldRequireClub,
      (button) => <RequireClub key="direct-message">{button}</RequireClub>,
    ),
  )

  const phone = advert?.contactPhone ?? user.phone
  const email = advert?.contactEmail ?? user.email

  const methods = [
    canSendDirectMessage ? directMessageButton : null,
    phone ? (
      <Button
        href={getPhoneHref(phone)}
        variant="outline"
        color="secondary"
        iconLeft={<PhoneAlt className="w-4" />}
        key={"phone"}
      >
        {phone.formatted}
      </Button>
    ) : null,
    user.mobile ? (
      <Button
        href={getPhoneHref(user.mobile)}
        variant="outline"
        color="secondary"
        iconLeft={<PhoneAlt className="w-4" />}
        key={"mobile"}
      >
        {user.mobile.formatted}
      </Button>
    ) : null,
    email ? (
      <Button
        href={`mailto:${email}`}
        variant="outline"
        color="secondary"
        iconLeft={<At className="w-4" />}
        key={"email"}
      >
        {email}
      </Button>
    ) : null,
    user.website ? (
      <Button
        href={user.website}
        external
        variant="outline"
        color="secondary"
        iconLeft={<MousePointer className="w-3" />}
        key={"website"}
      >
        {translator.trans(
          "ProfilePage.contactMethods.website",
          null,
          "components",
        )}
      </Button>
    ) : null,
    user.whatsApp ? (
      <Button
        href={`https://wa.me/${user.whatsApp.formatted.replaceAll(" ", "")}`}
        external
        variant="outline"
        color="secondary"
        iconLeft={<Whatsapp className="w-4" />}
        key={"whatsapp"}
      >
        {translator.trans(
          "ProfilePage.contactMethods.whatsapp",
          null,
          "components",
        )}
      </Button>
    ) : null,
    user.skype ? (
      <Button
        href={`skype:${user.skype}`}
        external
        variant="outline"
        color="secondary"
        iconLeft={<Skype className="w-4" />}
        key={"skype"}
      >
        {translator.trans(
          "ProfilePage.contactMethods.skype",
          null,
          "components",
        )}
      </Button>
    ) : null,
    advert && advert.contactOther ? (
      advert.contactOther.startsWith("http") ? (
        <Button
          href={advert.contactOther}
          external
          variant="outline"
          color="secondary"
          key={"other"}
        >
          {advert.contactOther}
        </Button>
      ) : (
        <Text
          className="text-center text-primary-dark"
          variant="button"
          key={"other"}
        >
          {advert.contactOther}
        </Text>
      )
    ) : null,
  ].filter((method) => method !== null)

  if (methods.length === 0) return null

  const mainMethods = methods.slice(0, 2)
  const otherMethods = methods.slice(2)

  return (
    <div className="flex flex-col space-y-4">
      {mainMethods}
      {otherMethods.length > 0 ? (
        showOtherContactMethods ? (
          otherMethods
        ) : (
          <Button
            color="secondary"
            variant="outline"
            onClick={() => setShowOtherContactMethods(true)}
          >
            {otherContactMethodsTitle}
          </Button>
        )
      ) : null}
    </div>
  )
}
